import { getColorByIndex } from '@hotjar/charts';
import type { FilterType } from '@hotjar/global-filters';
import { getDefaultDateRange, getDefaultFilterInUiFormat } from '@hotjar/global-filters';
import { v4 as uuid } from 'uuid';
import { getSeriesLabel } from '../../utils/getSeriesLabel';
import { ChartType } from '../dashboard/model';
import { getStepSeriesLabel } from './getStepSeriesLabel';

import type { FunnelQuery } from './model';

export const getDefaultFunnelQuery = (): FunnelQuery => {
  const defaultFilter = getDefaultFilterInUiFormat();
  const defaultStep: FilterType[] = [];
  return {
    dateRange: getDefaultDateRange(),
    filterChainSeries: [
      {
        key: uuid(),
        filtersInUiFormat: defaultFilter.filterList,
        color: getColorByIndex(0),
        label: getSeriesLabel(defaultFilter.filterList),
      },
    ],
    steps: [
      {
        key: uuid(),
        stepInUiFormat: defaultStep,
        label: getStepSeriesLabel(defaultStep),
      },
      {
        key: uuid(),
        stepInUiFormat: defaultStep,
        label: getStepSeriesLabel(defaultStep),
      },
    ],
    chartType: ChartType.bar,
  };
};
